<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-divider align='left'>
  <div class='d-inline-flex align-items-center gap-2 color-gray-2 fw-medium'>
    @if (faIconClass() !== null) {
      <i class='fa-solid {{faIconClass()}} {{iconSize()}}'></i>
    }
    <p class='{{textSize()}}'>{{ text() }}</p>
  </div>
</p-divider>


